import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Users, MapPin, Heart, Utensils, User } from 'lucide-react';
import { useUser } from '../contexts/UserContext';

const MobileNavBar: React.FC = () => {
  const location = useLocation();
  const { user } = useUser();
  
  // Only show for authenticated users
  if (!user) return null;
  
  // Only show on mobile
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="flex justify-around items-center h-16">
        <Link 
          to="/nearby-listings" 
          className={`flex flex-col items-center justify-center w-full h-full ${
            location.pathname === '/nearby-listings' ? 'text-orange-500' : 'text-gray-500'
          }`}
        >
          <Users className="h-6 w-6" />
          <span className="text-xs mt-1">Anfragen</span>
        </Link>
        
        <Link 
          to="/nearby" 
          className={`flex flex-col items-center justify-center w-full h-full ${
            location.pathname === '/nearby' ? 'text-orange-500' : 'text-gray-500'
          }`}
        >
          <MapPin className="h-6 w-6" />
          <span className="text-xs mt-1">In der Nähe</span>
        </Link>
        
        <Link 
          to="/blind-dates" 
          className={`flex flex-col items-center justify-center w-full h-full ${
            location.pathname === '/blind-dates' ? 'text-orange-500' : 'text-gray-500'
          }`}
        >
          <Heart className="h-6 w-6" />
          <span className="text-xs mt-1">Blind Dates</span>
        </Link>
        
        <Link 
          to="/my-dinners" 
          className={`flex flex-col items-center justify-center w-full h-full ${
            location.pathname === '/my-dinners' ? 'text-orange-500' : 'text-gray-500'
          }`}
        >
          <Utensils className="h-6 w-6" />
          <span className="text-xs mt-1">Meine Dinner</span>
        </Link>
        
        <Link 
          to="/profile" 
          className={`flex flex-col items-center justify-center w-full h-full ${
            location.pathname === '/profile' ? 'text-orange-500' : 'text-gray-500'
          }`}
        >
          <User className="h-6 w-6" />
          <span className="text-xs mt-1">Profil</span>
        </Link>
      </div>
    </div>
  );
};

export default MobileNavBar;